
import React, { PureComponent } from 'react';
import { Card, Col, Icon, Row } from 'antd';
import { Container } from '../../../../components';
import { AppWrappperHOC } from '../../../Root/HOC';
import { StyledAuditCommittee } from '../StyledIPO';

class DisclosuresRegulationGeneralMeetings extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <StyledAuditCommittee>
        <Container>
          <Card className="rounded card-padding-20">
            <h2 className="text-red">General Meetings</h2>

            <div style={{ margin: '26px 16px 16px 0px' }}>
              <a
                target="_blank"
                href="https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/general-meeting/postal-ballot-notice-postal-ballot-notice-09-11-2023.pdf"
                style={{
                  color: ' #000000',
                  fontSize: '16px',
                  border: 'none',
                  background: 'transparent',
                  margin: '16px 0px 16px 16px',
                }}
              >
                Postal Ballot notice 09.11.2023
              </a>
            </div>
          </Card>
        </Container>
      </StyledAuditCommittee>
    );
  }
}

const component = AppWrappperHOC(DisclosuresRegulationGeneralMeetings);

export { DisclosuresRegulationGeneralMeetings };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/DisclosuresRegulationGeneralMeetings/index.jsx